import React from 'react';

import * as S from './style';

export type TProps = {
  value: number | string;
  className?: string;
  noDivider?: boolean;
};

const Percent = React.memo<TProps>(({className, value, noDivider}) => {
  if (Number.isNaN(Number(value))) {
    return <>0</>;
  }

  return (
    <S.Percent className={className}>
      {value}
      <S.PercentSymbol noMarginLeft={noDivider}>%</S.PercentSymbol>
    </S.Percent>
  );
});

export default Percent;
